function Footer() {
    return (<>
        <footer class="dashboard">
            <p> @ 2020 Collective. All Rights Reserved</p>
                 {/* | Design by <a href="https://webmindstechnologies.com/" target="_blank" rel="noopener noreferrer"
                class="text-primary">Sanjay Tiwari</a> */}
        </footer>
        <button onClick="topFunction()" id="movetop" class="bg-primary" title="Go to top">
            <span class="fa fa-angle-up"></span>
        </button>
    </>)
}

export default Footer